import React from "react";

const NotFound = () =>{
    return(
    <div className="col-md-12">
        <div className="w-100 element-row-message border-content-sections d-flex justify-content-center pt-5 pb-5">
        <span>Documentos no disponibles</span>
        </div>
    </div>
    
    )
}

export default NotFound;

